<template>
    <v-layout wrap>
        <v-navigation-drawer absolute permanent right style="width:17%">

            <v-list class="pa-1">
                <v-card
                        class="mx-auto"
                        tile
                        dense
                >
                    <v-list flat style="margin-bottom: 80px;">

                        <v-overlay :value="showReplayLoading">
                            <v-col align="center">
                                <div> Loading...</div>
                                <v-progress-circular indeterminate size="64"></v-progress-circular>
                            </v-col>
                        </v-overlay>

                        <v-list-item-group
                                v-if="!showReplayLoading &&  filteredQueueLists && filteredQueueLists.length > 0"
                                v-model="queueIndex"
                                :mandatory="true"
                                color="indigo"
                                active-class="border"
                        >
                            <v-list-item
                                    v-for="(queue,index) in filteredQueueLists"
                                    :key="index"
                            >

                                <v-list-item-content v-if="queue.key.includes('init')">
                                    <v-btn text color="black" block> Init</v-btn>
                                </v-list-item-content>


                                <v-list-item-avatar v-if="!queue.key.includes('init')" style="margin-right: 1px">
                                    <v-img :src="queue.userImg"></v-img>
                                </v-list-item-avatar>

                                <v-list-item-content v-if="!queue.key.includes('init')">
                                    <v-row v-for="chip in queue.chips" dense
                                           style="max-width: fit-content; margin-left: 5px;">
                                        <v-chip small :color="chip.color">{{chip.state}}</v-chip>
                                    </v-row>

                                    <v-expansion-panels
                                            multiple
                                            accordion
                                    >
                                        <v-expansion-panel>
                                            <v-expansion-panel-header style="font-size: 13px;">
                                                {{ queue&& queue.elementComment ? queue.elementComment.display :null}}
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content style="font-size: 10px;">
                                                {{ queue&& queue.elementComment ? queue.elementComment.detail :null}}
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>

                                    <div align="end" style="font-size: 10px; margin-right: 10px">{{ queue.elementTimeAgo
                                        }}
                                    </div>
                                </v-list-item-content>

                            </v-list-item>
                        </v-list-item-group>

                        <div v-if="!showReplayLoading && filteredQueueLists && filteredQueueLists.length == 0"> No
                            Data
                        </div>
                    </v-list>

                </v-card>

            </v-list>
        </v-navigation-drawer>
    </v-layout>
</template>

<script>
    // import StorageBase from "./StorageBase";
    import StorageBase from "./ModelStorageBase";
    import TimeAgo from 'javascript-time-ago'
    import ko from 'javascript-time-ago/locale/ko'

    TimeAgo.addLocale(ko)
    const timeAgo = new TimeAgo('ko-KO')

    var jsondiffpatch = require('jsondiffpatch').create({
        objectHash: function (obj, index) {
            return '$$index:' + index;
        },
    });
    export default {
        name: 'replay-panel',
        mixins: [StorageBase],
        props: {
            value: Object,

            startQueueKey: {
                type: String,
                default: function () {
                    return '';
                }
            },
            endQueueKey: {
                type: String,
                default: function () {
                    return '';
                }
            },
            sliderIndex: {
                type: Number,
                default: function () {
                    return 0;
                }
            },
            sliderSize: {
                type: Number,
                default: function () {
                    return 0;
                }
            },
            sliderLists: {
                type: Array,
                default: function () {
                    return [];
                }
            },

            tmpCommentLists: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            tmpEditUserImgLists: {
                type: Object,
                default: function () {
                    return {}
                }
            }
        },
        data() {
            return {
                queueLists: null,
                queueIndex: -1,
                showReplayLoading: false,

                params: {
                    projectId: null,
                    snapshotKey: null,
                    queueKey: null,
                },


            }
        },
        created() {
        },
        computed: {
            filteredQueueLists() {
                return this.queueLists
            },
            getSnapKey() {
                var me = this
                return me.sliderLists[me.sliderIndex].snapKey
            },
            getQueueKey() {
                return this.$route.params.queueKey
            },
            getProjectId() {
                return this.$route.params.projectId
            }
        },
        watch: {
            "startQueueKey": function (newVal) {
                this.showReplayLoading = true
                this.queueIndex = -1
                this.init()
            },
            "params.queueKey": async function (newVal, oldVal) {
                var me = this

                if (me.queueLists && me.queueLists.length > 0 && me.queueIndex != -1) {
                    if (me.queueIndex == 0) {
                        //first
                        if (me.queueLists[me.queueIndex].key == 'init') {
                            me.$emit('prevSnap')
                        } else if (me.queueLists[me.queueIndex].key == newVal) {
                            me.$emit('prevSnap')
                            me.moveQueue(me.startQueueKey, newVal)
                        } else {
                            console.log('what??')
                        }

                    } else if (me.queueLists.length - 1 == me.queueIndex) {
                        //last
                        me.moveQueue(me.startQueueKey, newVal)
                        me.$emit('nextSnap')
                    } else {

                        if (oldVal == 'init') oldVal = ''
                        if (newVal > oldVal) {
                            me.moveQueue(oldVal, newVal)
                        } else {
                            me.$emit('prevSnap')
                            me.moveQueue(me.startQueueKey, newVal)
                        }
                    }

                    me.changeUrl(null, null, '/#/replay/' + me.getProjectId + '/' + me.getSnapKey + '/' + newVal)
                } else if (newVal && !oldVal) {
                    await me.init()

                }
            },
            "queueIndex": function (newVal) {
                var me = this
                if (me.queueLists.length > 0 && newVal != -1) {
                    var newQueueKey = me.queueLists[newVal].key
                    me.params.queueKey = newQueueKey
                }
            },
            // "queueIndex": function (newVal, oldVal) {
            //     var me = this
            //     var prevKey, nextKey
            //     var parmKey
            //     if (me.queueLists.length > 0 && newVal != -1) {
            //
            //
            //         if (newVal == 0) {
            //             //first
            //             nextKey = me.queueLists[newVal].key
            //             // nextKey = me.params.queueKey
            //
            //             if (me.startQueueKey.includes('last')) {
            //                 if (me.sliderLists[me.sliderIndex - 1].lastQueueKey == '') {
            //                     prevKey = null
            //                 } else {
            //                     prevKey = me.sliderLists[me.sliderIndex - 1].lastQueueKey
            //                 }
            //             }
            //
            //             me.moveQueue(prevKey, nextKey)
            //
            //         } else if (me.queueLists.length - 1 == newVal) {
            //             //last
            //             if (me.startQueueKey.includes('last')) {
            //                 prevKey = me.queueLists[0].key == 'init' ? '' : me.queueLists[0].key
            //                 nextKey = me.queueLists[newVal].key
            //                 // nextKey = me.params.queueKey
            //
            //                 me.moveQueue(prevKey, nextKey)
            //             } else {
            //                 me.$emit('nextSnap')
            //             }
            //
            //         } else {
            //             //center
            //
            //             if (oldVal < newVal) {
            //                 prevKey = me.queueLists[oldVal + 1].key
            //                 nextKey = me.queueLists[newVal].key
            //                 // nextKey = me.params.queueKey
            //                 me.moveQueue(prevKey, nextKey)
            //             } else {
            //                 me.$emit('prevSnap')
            //                 prevKey = me.queueLists[0].key == 'init' ? null : me.queueLists[0].key
            //                 nextKey = me.queueLists[newVal].key
            //                 // nextKey = me.params.queueKey
            //                 me.moveQueue(prevKey, nextKey)
            //             }
            //
            //         }
            //
            //         var snapshotKey = me.sliderLists[me.sliderIndex] ? me.sliderLists[me.sliderIndex].snapKey : 'last'
            //
            //         if (!nextKey) {
            //             parmKey = 'init'
            //         } else {
            //             parmKey = nextKey
            //         }
            //         me.changeUrl(null, null, '/#/replay/' + me.params.projectId + '/' + snapshotKey + '/' + parmKey)
            //
            //     }
            //
            // },

        },
        methods: {
            async init() {
                var me = this
                var option = null
                me.queueLists = []

                console.log('init::', me.startQueueKey, '/', me.endQueueKey, '<< ')

                if (!me.startQueueKey && !me.endQueueKey) {
                    var getStartQueue = await me.getString(`db://definitions/${me.getProjectId}/snapshotLists/${me.getSnapKey}/lastSnapshotKey`)
                    if (!getStartQueue) getStartQueue = ''

                    option = {
                        sort: null,
                        orderBy: null,
                        size: null,
                        startAt: getStartQueue,
                        endAt: me.queueKey,
                    }
                } else {

                    if (me.startQueueKey == '') {
                        me.queueLists.push(
                            {key: 'init', value: null}
                        )

                       option = {
                            sort: null,
                            orderBy: null,
                            size: null,
                            startAt: null,
                            endAt: me.endQueueKey,
                        }
                    } else if (me.endQueueKey == 'last') {
                        option = {
                            sort: null,
                            orderBy: null,
                            size: null,
                            startAt: me.startQueueKey,
                            endAt: null,
                        }
                    } else {
                        option = {
                            sort: null,
                            orderBy: null,
                            size: null,
                            startAt: me.startQueueKey,
                            endAt: me.endQueueKey,
                        }
                    }

                }


                var getSnapshot = await me.list(`db://definitions/${me.getProjectId}/queue`, option)
                // getSnapshot = Array.isArray(getSnapshot) ? getSnapshot : Object.values(getSnapshot)
                if (getSnapshot) {
                    getSnapshot.forEach((item) => {
                        var queueValue = item
                        var queuekey = queueValue.key
                        if (!queueValue.action.includes('user')) {
                            var obj = {
                                key: queuekey,
                                value: queueValue,
                            }
                            me.queueLists.push(obj)
                        }
                    })
                    me.settingLists()
                    var findIndex = me.queueLists.findIndex(queue => queue.key == me.getQueueKey)
                    me.queueIndex = findIndex == -1 ? 0 : findIndex
                } else {
                    me.showReplayLoading = false
                }


            },
            async settingLists() {
                var me = this

                if (me.queueLists.length > 0) {
                    for (const queue of me.queueLists) {
                        if (!queue.key.includes('init')) {

                            //chip
                            var action
                            queue.chips = []
                            if (queue.value.action.includes('undo') || queue.value.action.includes('redo')) {
                                action = JSON.parse(queue.value.item).childValue.action
                                if (queue.value.action.includes('undo')) {
                                    queue.chips.push({color: 'orange lighten-3', state: queue.value.action})
                                } else {
                                    queue.chips.push({color: 'orange lighten-3', state: queue.value.action})
                                }
                            } else {
                                action = queue.value.action

                            }
                            var color = action.includes('Push') ? 'light-blue darken-1' : (action.includes('Delete') ? 'deep-orange darken-1' : 'green darken-1')
                            var state = action.includes('Move') ? 'Move' : action.includes('Modify') ? 'Modify' : action.includes('Push') ? 'Add' : 'Delete'

                            var chip = {color: color, state: state}
                            queue.chips.push(chip)


                            //user

                            if (me.tmpEditUserImgLists[queue.value.editUid]) {
                                queue.userImg = me.tmpEditUserImgLists[queue.value.editUid]
                            } else {
                                queue.userImg = await me.editUserImg(queue)
                                me.tmpEditUserImgLists[queue.value.editUid] = queue.userImg
                            }

                            if (me.tmpCommentLists[queue.key]) {
                                queue.elementComment = me.tmpCommentLists[queue.key]
                            } else {
                                queue.elementComment = me.elementComment(queue)
                                me.tmpCommentLists[queue.key] = queue.elementComment
                            }

                            queue.elementTimeAgo = timeAgo.format(queue.value.timeStamp)
                        } else {
                            // queue.elementTimeAgo = timeAgo.format(queue.value.timeStamp)
                        }
                    }
                }
                me.showReplayLoading = false

            },

            changeUrl(state, title, url) {
                if (typeof (history.pushState) != "undefined") { //브라우저가 지원하는 경우
                    history.pushState(state, title, url);
                } else {
                    location.href = url; //브라우저가 지원하지 않는 경우 페이지 이동처리
                }
            },
            async moveQueue(prevKey, NextKey) {
                var me = this

                if (prevKey && NextKey) {
                    // o------o
                    var option = {
                        sort: null,
                        orderBy: null,
                        size: null,
                        startAt: prevKey,
                        endAt: NextKey,
                    }
                } else if (prevKey && !NextKey) {
                    // o------>
                    var option = {
                        sort: null,
                        orderBy: null,
                        size: null,
                        startAt: prevKey,
                        endAt: null,
                    }
                } else if (!prevKey && NextKey) {
                    // >------o
                    var option = {
                        sort: null,
                        orderBy: null,
                        size: null,
                        startAt: null,
                        endAt: NextKey,
                    }
                } else {
                    // <------>
                    var option = {
                        sort: null,
                        orderBy: null,
                        size: null,
                        startAt: null,
                        endAt: null,
                    }
                }


                var getSnapshot = await me.list(`db://definitions/${me.getProjectId}/queue`, option)
                if (getSnapshot) {
                    getSnapshot.forEach((item) => {
                        var queueValue = item
                        var queuekey = queueValue.key
                        if (!queueValue.action.includes('user')) {
                            var queue = {
                                childKey: queuekey,
                                childValue: queueValue
                            }
                            me.receivedQueueDrawElement(queue, true)
                        }
                    })
                }


            },
            async editUserImg(queue) {
                var me = this

                var img = await me.getString(`db://users/${queue.value.editUid}/profile_picture`)
                if (img) {
                    return img
                }
                return 'https://cdn.vuetifyjs.com/images/john.jpg'
            },
            getDiffValues(diffJson) {
                var me = this
                var label = {index: null, type: null, changed: {}}

                function getDiffValue(diffJson) {
                    Object.keys(diffJson).forEach(function (type, index) {
                        var val = diffJson[type]
                        var index = Object.keys(val)[0]


                        if (type == 'elements') {
                            label.index = index
                            label.type = type
                        } else {
                            if (type != '0' && type != '1' && index != '_type' && type != 'elements') {
                                label.changed[type] = val
                            }

                        }


                        if (type != '_t' && val[index] && typeof val[index] == 'object') {
                            getDiffValue(val[index])
                        }
                    })
                }


                getDiffValue(diffJson)
                return label

            },
            elementComment(queue) {
                var me = this
                var comment = {
                    display: '',
                    detail: ''
                }

                var valueIndex = null

                var action = queue.value.action
                var item = queue.value.item ? JSON.parse(queue.value.item) : queue.value

                if (action.includes('undo') || action.includes('redo')) {
                    var undoDiff = JSON.parse(queue.value.item)
                    item = undoDiff.childValue.item ? JSON.parse(undoDiff.childValue.item) : undoDiff.childValue
                    action = JSON.parse(queue.value.item).childValue.action
                }

                if (action.includes('relation')) {

                    if (action.includes('Push')) {

                        var source = item.sourceElement
                        var target = item.targetElement

                        comment.display = '[선] \"' + source.name + ' \" [ ' + source._type.split('.')[4] + ' ] -> \"' + target.name + ' \" [ ' + target._type.split('.')[4] + ' ]' + '를 연결합니다.'
                        comment.detail = ''

                    } else if (action.includes('Delete')) {

                        var source = item.sourceElement
                        var target = item.targetElement


                        comment.display = '[선] \"' + source.name + ' \" [ ' + source._type.split('.')[4] + ' ] ->\"' + target.name + ' \" [ ' + target._type.split('.')[4] + ' ]' + '를 삭제 합니다.'
                        comment.detail = ''

                    } else if (action.includes('Move')) {

                        var relation = me.value.relations[item.relationId]
                        if (relation) {
                            var source = relation.sourceElement
                            var target = relation.targetElement
                            comment.display = '[선] \" ' + source.name + '\" [' + source._type.split('.')[4] + '] ->  \" ' + source.name + '\" [' + source._type.split('.')[4] + '] 이동 합니다.'
                            comment.detail = ''
                        } else {
                            comment.display = '[선] 이동합니다.'
                            comment.detail = ''
                        }

                        // comment.display = '\" ' + item.elementName + '\"인 [ ' + item.elementType + ' ]가 이동 합니다.'
                        // comment.detail = '[ X: ' + JSON.parse(item.before).x + '/ Y: ' + JSON.parse(item.before).y + '] \n'
                        //     + ' => [ X: ' + JSON.parse(item.after).x + '/ Y: ' + JSON.parse(item.after).y + '] \n'

                    } else if (action.includes('Modify')) {
                        comment.display = '준비중 입니다.'
                        comment.detail = ''
                    }

                } else {
                    if (action.includes('Push')) {

                        comment.display = '\"' + item.name + ' \" 인[ ' + item._type.split('.')[4] + ' ]를 추가 합니다.'
                        comment.detail = 'X좌표: ' + item.elementView.x + '/ Y좌표: ' + item.elementView.y

                    } else if (action.includes('Delete')) {

                        comment.display = '\"' + item.name + ' \" 인[ ' + item._type.split('.')[4] + ' ]를 삭제 합니다.'
                        comment.detail = 'X좌표: ' + item.elementView.x + '/ Y좌표: ' + item.elementView.y

                    } else if (action.includes('Move')) {

                        comment.display = '\" ' + item.elementName + '\"인 [ ' + item.elementType + ' ]가 이동 합니다.'
                        comment.detail = '[ X: ' + JSON.parse(item.before).x + '/ Y: ' + JSON.parse(item.before).y + '] \n'
                            + ' => [ X: ' + JSON.parse(item.after).x + '/ Y: ' + JSON.parse(item.after).y + '] \n'

                    } else if (action.includes('Modify')) {
                        var diff = item
                        var id = Object.keys(diff.elements)[0]
                        // var copyValue = JSON.parse(JSON.stringify(me.value))
                        var copyValue = me.value
                        var elementName = copyValue.elements[id] ? copyValue.elements[id].name : ''
                        var elementType = copyValue.elements[id] ? copyValue.elements[id]._type.split('.')[4] : ''

                        var diffParse = me.getDiffValues(diff)

                        comment.display = '\"' + elementName + ' \"인 [ ' + elementType + ' ]를 수정 합니다. '

                        Object.entries(diffParse.changed).forEach(function (key) {
                            if (typeof key[1] == 'object' && !Array.isArray(key[1])) {
                                comment.detail = comment.detail + key[0] + ', '
                            } else if (Array.isArray(key[1])) {
                                comment.detail = comment.detail + '[' + key[0] + ': ' + key[1][0] + ' -> ' + key[1][1] + '], '
                            } else {
                                comment.detail = comment.detail + ''
                            }
                        })
                        // Object.keys(diffParse.changed).forEach(function (key) {
                        //     console.log('keys: ',key,diffParse.changed[key])
                        //     // comment.detail = comment.detail ? comment.detail + ', ' + key : key
                        // })
                        comment.detail = comment.detail + ' 변경되었습니다.'

                    }
                }


                return comment
            },

            receivedQueueDrawElement(child, ignore) {
                var me = this
                ignore = ignore ? ignore : false

                if (child != undefined) {
                    var item = null
                    var afterMove = null
                    var action = child.childValue.action ? child.childValue.action : child.childValue.state

                    if (action == 'undo' || action == 'redo') {
                        // changedByMe
                        ignore = true
                        child = JSON.parse(child.childValue.item)
                        action = child.childValue.action
                    }

                    if (action.includes('Move')) {
                        afterMove = child.childValue.after
                    } else {
                        item = child.childValue.item ? JSON.parse(child.childValue.item) : null
                    }


                    //origin
                    if (action == 'elementPush') {

                        if (me.specVersion == '2.0') {

                            me.value.definition.push(item)

                        } else {
                            if (!ignore && child.childKey < me.prevKey) {
                                console.log('Wrong Order: elementPush ', child.childKey, 'prevKey:', me.prevKey, child)
                                alert('Concurrent editing is unsynchronized. Page will be reloaded.')
                                window.location.reload(true)
                            }

                            if (ignore || child.childKey != me.prevKey) {
                                me.prevKey = child.childKey
                                me.$set(me.value.elements, item.elementView.id, item)
                                // console.log('received Queue : push Element')
                            } else {
                                console.log('reduplication Element Push')
                            }

                        }

                    } else if (action == 'elementDelete') {


                        try {

                            if (me.specVersion == '2.0') {
                                var obj = {
                                    action: 'delete',
                                    element: JSON.stringify(item)
                                }
                                me.$nextTick(function () {
                                    me.$EventBus.$emit(`${item.elementView.id}`, obj)
                                })

                            } else {
                                me.value.elements[item.elementView.id] = null;
                            }

                        } catch (e) {
                            console.log('Wrong Order', 'now', child.childKey, 'prev:', me.prevKey, child)
                            alert('Concurrent editing is unsynchronized. Page will be reloaded.')
                            window.location.reload(true)
                        }

                    } else if (action == 'elementMove') {

                        try {
                            var elementId = child.childValue.elementId

                            var obj = {
                                action: 'elementMove',
                                element: afterMove,
                            }

                            me.onMoveElementById(elementId, afterMove)
                            me.$nextTick(function () {
                                me.$EventBus.$emit(`${elementId}`, obj)
                            })


                        } catch (e) {
                            console.log('Wrong Order', 'now', child.childKey, 'prev:', me.prevKey, child)
                            alert('Concurrent editing is unsynchronized. Page will be reloaded.')
                            window.location.reload(true)
                        }


                    } else if (action == 'valueModify') {

                        try {
                            //changedByMe
                            if (!ignore && me.changedByMeKeys.includes(child.childKey)) {
                                me.changedByMeKeys.splice(me.changedByMeKeys.indexOf(child.childKey), 1)
                            } else {
                                jsondiffpatch.patch(me.value, item)
                            }

                        } catch (e) {
                            console.log('patchError:', e, JSON.parse(JSON.stringify(me.value)), JSON.parse(child.childValue.item))
                            alert('Concurrent editing is unsynchronized. Page will be reloaded(patchError)')
                            window.location.reload(true)
                        }

                    } else if (action == 'relationPush') {

                        // var item = JSON.parse(child.childValue.item)
                        if (me.specVersion == '2.0') {
                            me.value.relation.push(item);
                        } else {
                            if (!ignore && child.childKey < me.prevKey) {
                                console.log('Wrong Order', 'now', child.childKey, 'prev:', me.prevKey, child)
                                alert('Concurrent editing is unsynchronized. Page will be reloaded.')
                                window.location.reload(true)
                            }

                            if (ignore || child.childKey != me.prevKey) {
                                me.prevKey = child.childKey

                                me.$set(me.value.relations, item.relationView.id, item)

                            } else {
                                console.log('reduplication Relation Push')
                            }
                        }


                    } else if (action == 'relationDelete') {

                        try {
                            if (me.specVersion == '2.0') {
                                var obj = {
                                    action: 'delete',
                                    element: JSON.stringify(item)
                                }
                                me.$nextTick(function () {
                                    me.$EventBus.$emit(`${item.relationView.id}`, obj)
                                })
                            } else {
                                me.value.relations[item.relationView.id] = null;
                            }
                        } catch (e) {
                            console.log('Wrong Order', 'now', child.childKey, 'prev:', me.prevKey, child)
                            alert('Concurrent editing is unsynchronized. Page will be reloaded.')
                            window.location.reload(true)
                        }


                    } else if (action == 'relationMove') {

                        try {
                            // var afterMove = child.childValue.after
                            var relatinId = child.childValue.relationId

                            var obj = {
                                action: 'relationMove',
                                element: afterMove
                            }

                            me.$nextTick(function () {
                                me.$EventBus.$emit(`${relatinId}`, obj)
                            })

                        } catch (e) {
                            console.log('Wrong Order', 'now', child.childKey, 'prev:', me.prevKey, child)
                            alert('Concurrent editing is unsynchronized. Page will be reloaded.')
                            window.location.reload(true)
                        }
                    }
                }

            },
            onMoveElementById(id, newValueStr) {
                var me = this

                if (me.value && me.value.elements && me.value.elements[id]) {
                    var newValueObj = JSON.parse(newValueStr)

                    me.value.elements[id].elementView.x = newValueObj.x
                    me.value.elements[id].elementView.y = newValueObj.y
                    me.value.elements[id].elementView.width = newValueObj.width
                    me.value.elements[id].elementView.height = newValueObj.height
                }
            },
        },
    }
</script>

<style>
    .border {
        border: 2px dashed orange;
    }
</style>